export class MessageRequest {
    public message: string;
    public idMessageType: string;
}